module.exports = __webpack_public_path__ + "img/miss-you.73835361.png";